<style scoped lang="less">
  .box {
    position: relative;
  }

  @media (max-width: 767px) {
    /* <== You can change this break point as per your  needs */
    .buttonContainer {
      flex-direction: column;
      display: flex;
      position: absolute;
      top: 0;
      justify-content: space-around;
      height: 100%;
      right: 0;
    }
  }
</style>
<template>
  <div>
    <div class="box mb-0 m-1 align-center">
      <div
        class="columns"
        @click="toggle"
      >
        <span class="column">
          <div>
            <router-link :to="`/venue/${tournData.venue}`">
              {{ tournData.name }}
            </router-link>
          </div>
          <div>
            {{ $moment(tournData.date).format("MMM DDD, YYYY") }}
          </div>
        </span>
        <div class="column">
          <strong>Added By:</strong> {{ tournData.addedby }}
        </div>
        <div class="column">
          <div><strong>HC:</strong> {{ tournData.headcount }}</div>
          <div><strong>ENT:</strong> {{ tournData.entrants }}</div>
        </div>
        <span class="column is-pulled-right has-text-right buttonContainer is-flex">
          <a
            v-if="this.editButton"
            data-tooltip="Edit"
            class="btn-icon tooltip"
            @click="editTourn"
          >
            <i class="far fa-edit" />
          </a>
          <a
            v-if="this.deleteButton"
            data-tooltip="Delete"
            class="btn-icon tooltip"
            @click="deleteTourn"
          >
            <i class="far fa-trash" />
          </a>
          <a
            v-if="this.deleteButton"
            data-tooltip="Approve Tournament"
            class="btn-icon tooltip"
            @click="approveTourn"
          >
            <i class="far fa-thumbs-up" />
          </a>
          <a
            v-if="this.invoiceButton"
            data-tooltip="Invoice"
            class="btn-icon tooltip"
            @click="invoiceTourn"
          >
            <i class="far fa-file-invoice-dollar" />
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'TournamentCard',
    components: {
      axios
    },
    props: ['token', 'tournData', 'editButton', 'approveTournament', 'deleteButton', 'invoiceButton'],
    data() {
      return {
        isCollapsed: true,
      }
    },
    watch: {},
    mounted() {
    },
    methods: {
      toggle() {
        this.isCollapsed = !this.isCollapsed
      },
      editTourn() {
        this.router.push(`/admin/tournaments/edit/${this.tournData.tournid}`)
      },
      deleteTourn() {
        let url = `admin/tournaments/deletetournament`
        let data = {
          token: this.token,
          tournid: this.tournData.tournid
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            if (res.data.message) {
              this.$emit('message',
                {
                  showDialog: true,
                  error: res.data.error,
                  message: res.data.message
                })
            }
            if (!res.data.error) {
              this.$emit('tournamentAltered')
            }
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
      },
      approveTourn() {
        this.$emit('approve-Tournament', this.tournData)
      },
      invoiceTourn() {

      }
    }
  }
</script>
